const BASE_URL = "/api/sales-platform-servicer-base/"

let gateway_url = process.env.GATEWAY_ROOT;
let api_version = process.env.API_VERSION;
/** 创建token */
export const createTokenApi = (params, context, options) => {
  return fetch(`${gateway_url + BASE_URL}/create-token?version=${api_version}`, {
    headers: {
      "Accept": "*/*",
      "Content-type": "application/json",
      "withCredentials": true,
    },
    mode: 'cors',
    method: 'POST',
    body: JSON.stringify({ data: params })
  }).then(res => { return res.json() });
}



/**获取APP下载地址 **/
export  const  getAppReleaseVersionApi =  (params, context, options) => {
  let b_url = '/api/elechcy-servicer-app';
  return  fetch(`${gateway_url + b_url}/common-data-md/get-app-release-version?version=${api_version}`, {
    headers: {
      "Accept": "*/*",
      "Content-type": "application/json",
      "withCredentials": true,
    },
    mode: 'cors',
    method: 'POST',
    body: JSON.stringify( params)
  }).then(res => {
    return res.json()
  });
}



// WEBPACK FOOTER //
// ./src/api/yz.js